<template>
    <div class="row">
        <div class="col-md-4">
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Filtro" id="reglas-cobro-filter" v-model="filter" />

                <div class="input-group-append">
                    <button class="btn btn-primary" type="button" id="clean-filter" @click="clearFilter">
                        <i class="fas fa-redo"></i>
                    </button>
                </div>
            </div>
        </div>

        <table class="table table-hover table-borderless figma-table">
            <thead>
                <tr class="font-weight-bold text-center" style="background-color: #f3f3f3; color: #989898;">
                    <th>Concepto</th>
                    <th>Fecha de vigencia</th>
                    <th>Tipo de Alumno</th>
                    <th>Tipo de Cobro</th>
                    <th>Monto</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in filterRegs" :key="item.id">
                    <td>
                        <div class="d-flex align-items-center">
                            <div
                                class="bpill rounded-circle d-inline-flex justify-content-center align-items-center mr-2 bpill--servicio"
                                :class="{
                                    'bpill--inscripcion': item.codigos_detalles.nombre.includes('INS'),
                                    'bpill--colegiatura': item.codigos_detalles.nombre.includes('COL'),
                                }">
                                <span v-if="item.codigos_detalles.nombre.includes('INS')">I</span>
                                <span v-else-if="item.codigos_detalles.nombre.includes('COL')">C</span>
                                <span v-else>S</span>
                            </div>
                            <div>
                                {{ item.codigos_detalles.nombre }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="text-right">
                            <span><i class="far fa-calendar"></i> <strong>{{ item.f_vigencia }}</strong></span><br>
                            <span class="text-muted">{{ item.nombre_f_vigencia }}</span>
                        </div>
                    </td>

                    <td>
                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <div class="apill rounded-pill p-2 text-center" :class="{ 'apill--reingreso': item.tipo_alumno.includes('Rein'), 'apill--ingreso': item.tipo_alumno.includes('Nuevo') }">
                                <strong>{{ item.tipo_alumno }}</strong>
                            </div>
                            <div>{{ getPrograma(item.programa_id) }} - {{ getNivelAcademico(item.nivel_academico_id) }}</div>
                        </div>
                    </td>

                    <td class="text-center">
                        {{ item.tipo_cobro }}
                    </td>

                    <td>
                        <strong>{{ item.monto | currency }}</strong><br>
                        <span>{{ (item.leyenda_creditos) ? item.leyenda_creditos : '' }}</span>
                    </td>
                    <td>
                        <button data-toggle="modal" data-target="#editarModal" type="button" class="fbutton fbutton--edit editar-regla-cobro rounded-circle d-flex-inline justify-content-center" @click="editReglaCobro(item.id)">
                            <i class="fas fa-edit"></i>
                        </button>

                        <button data-toggle="modal" data-target="#eliminarRegistro" type="button" class="fbutton fbutton--delete eliminar-regla-cobro rounded-circle d-flex-inline align-items-center">
                            <i class="fas fa-trash-alt"></i>
                            <span hidden="hidden" class="btnModalGetClass">{{ item.id }}</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="col-12">
          <Editar :reglaCobroId="selectedReglaCobroId" />
        </div>
    </div>
</template>

<script>
  import Editar from './Editar.vue';

    import axios from 'axios';

    export default {
      components:{
        Editar
      },
        props: {
            regs: {
                type: Array,
                default: []
            },
        },
        methods: {
          editReglaCobro(reglaCobroId) {
            this.selectedReglaCobroId = reglaCobroId;
          },
            clearFilter() {
                this.filter = '';
            },
            getPrograma(programaId) {
                if (this.programas && this.programas.length > 0) {
                    return this.programas.filter(p => p.id == programaId)[0]?.text;
                }

                return '';
            },
            getNivelAcademico(nivelAcademicoId) {
                if (this.nivelesAcademicos && this.nivelesAcademicos.length > 0) {
                    return this.nivelesAcademicos.filter(n => n.id == nivelAcademicoId)[0]?.text;
                }

                return '';
            }
        },
        watch: {
            'regs': {
                immediate: true,
                async handler(newValue, oldValue) {
                    if (newValue.length > 0) {
                        const institucionId = newValue[0].institucion_id;

                        this.nivelesAcademicos = await axios.get(`/niveles-academicos/filtrar?institucion_id=${institucionId}`).then(response => response.data);
                        this.programas = await axios.get(`/programas/institucion/${institucionId}`).then(response => response.data);
                    }
                }
            }
        },
        computed: {
            filterRegs() {
                if (this.filter) {
                    return this.regs.filter(reg => {
                        const filterBy = [
                            reg.codigos_detalles.nombre,
                            reg.f_vigencia,
                            reg.tipo_alumno,
                            reg.tipo_cobro,
                            reg.monto,
                        ];

                        const sfilterBy = filterBy.map(x => x.toString().toLowerCase());

                        return sfilterBy.some(camp => camp.includes(this.filter.toLowerCase()));
                    });
                }

                return this.regs;
            }
        },
        data() {
            return {
                filter: '',
                nivelesAcademicos: [],
                programas: [],
                selectedReglaCobroId: 0,
            }
        },
    }
</script>

<style lang="scss" scoped>
.figma-table {
    .bpill {
        color: white;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }

    .bpill--servicio {
        background-color: purple;
    }

    .bpill--inscripcion {
        background-color: #33cf4c;
    }

    .bpill--colegiatura {
        background-color: #009efb;
    }

    thead th {
        padding: 20px;
    }

    thead th:first-child {
        border-top-left-radius: 20px;
        width: 180px;
    }

    thead th:nth-child(2) {
        width: 320px;
    }

    thead th:last-child {
        border-top-right-radius: 20px;
    }

    .apill {
        min-width: 150px;
    }

    .apill--reingreso {
        background-color: #baece6;
        color: #16beaa;
    }

    .apill--ingreso {
        background-color: #ffeed4;
        color: #ffa928;
    }

    .fbutton {
        border: none;
        width: 35px;
        height: 35px;
    }

    .fbutton--edit {
        background-color: #e3f7e2;
        color: #65cd65;
    }

    .fbutton--delete {
        background-color: #ffe4e6;
        color: #ff4757;
    }
}

</style>
